module.exports = __webpack_public_path__ + "assets/772da7024ee8be5700cc9900225cb492.png";